var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.37109,
    y: 0.828125,
    width: 29.1429,
    height: 19.4286,
    rx: 2.42857,
    fill: "#9DB3F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47119,
    y: 3.72656,
    width: 30.1429,
    height: 20.4286,
    rx: 2.92857,
    fill: "white",
    stroke: "#9DB3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6587 11.6204C11.6587 11.344 11.6043 11.0703 11.4985 10.8149C11.3928 10.5596 11.2377 10.3275 11.0423 10.1321C10.8468 9.93665 10.6148 9.78161 10.3594 9.67584C10.1041 9.57007 9.83038 9.51562 9.55398 9.51563C9.27758 9.51563 9.00388 9.57007 8.74852 9.67584C8.49316 9.78161 8.26113 9.93665 8.06569 10.1321C7.87024 10.3275 7.71521 10.5596 7.60943 10.8149C7.50366 11.0703 7.44922 11.344 7.44922 11.6204",
    stroke: "#9DB3F2",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44944 11.6218C7.44944 11.8982 7.50388 12.1719 7.60965 12.4273C7.71543 12.6826 7.87046 12.9146 8.06591 13.1101C8.26135 13.3055 8.49338 13.4606 8.74874 13.5663C9.0041 13.6721 9.2778 13.7266 9.5542 13.7266",
    stroke: "#9DB3F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44917 15.8288C7.44917 16.1052 7.50361 16.3789 7.60938 16.6343C7.71516 16.8897 7.87019 17.1217 8.06564 17.3171C8.26108 17.5126 8.49311 17.6676 8.74847 17.7734C9.00383 17.8792 9.27753 17.9336 9.55393 17.9336C9.83033 17.9336 10.104 17.8792 10.3594 17.7734C10.6147 17.6676 10.8468 17.5126 11.0422 17.3171C11.2377 17.1217 11.3927 16.8897 11.4985 16.6343C11.6043 16.3789 11.6587 16.1052 11.6587 15.8288",
    stroke: "#9DB3F2",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.659 15.8313C11.659 15.5549 11.6045 15.2812 11.4987 15.0259C11.393 14.7705 11.2379 14.5385 11.0425 14.343C10.847 14.1476 10.615 13.9926 10.3597 13.8868C10.1043 13.781 9.8306 13.7266 9.5542 13.7266",
    stroke: "#9DB3F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5542 8.11328V19.3387",
    stroke: "#9DB3F2",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5713 10.543H22.857",
    stroke: "#9DB3F2",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9424 17.3438H27.2281",
    stroke: "#9DB3F2",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5713 13.9414L27.2284 13.9414",
    stroke: "#9DB3F2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECheck);
export default __webpack_public_path__ + "static/media/e-check.35892699740a44a93f6411d240ba29af.svg";
export { ForwardRef as ReactComponent };